/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface GooglerpcStatus {
  /** @format int32 */
  code?: number;
  message?: string;
  details?: ProtobufAny[];
}

export interface MinioCatalog {
  id?: string;
  name?: string;
  namespace?: string;
  /** @format int64 */
  sysCreated?: string;
}

export interface MinioDirectPV {
  /** Detected version of DirectPV */
  version?: string;
}

export interface MinioFirewall {
  id?: string;
  name?: string;
  namespace?: string;
  /** @format int64 */
  sysCreated?: string;
}

export interface MinioKeyManager {
  id?: string;
  name?: string;
  namespace?: string;
  /** @format int64 */
  sysCreated?: string;
}

export interface MinioObserve {
  id?: string;
  name?: string;
  namespace?: string;
  /** @format int64 */
  sysCreated?: string;
  status?: MinioObserveStatus;
}

export interface MinioObserveServices {
  server?: MinioServiceDetails;
  db?: MinioServiceDetails;
  ingest?: MinioServiceDetails;
}

export interface MinioObserveStatus {
  currentState?: string;
  services?: MinioObserveServices;
}

export interface MinioOperator {
  /** Detected version of MinIO Operator */
  version?: string;
  /** Detected version of MinIO Enterprise Operator */
  enterpriseVersion?: string;
  /** Namespace where operators are installed */
  namespace?: string;
}

export interface MinioPool {
  /** @format int32 */
  servers?: number;
  /** @format int32 */
  drivesPerServer?: number;
}

export interface MinioRPCError {
  errorMessage?: string;
  detailedError?: string;
  validations?: MinioValidationError[];
}

export interface MinioServiceDetails {
  healthStatus?: string;
  /** @format int32 */
  podsRunning?: number;
  /** @format int32 */
  podsCrashing?: number;
}

/** @default "k8s" */
export enum MinioSetupType {
  K8S = "k8s",
  Aks = "aks",
  Eks = "eks",
  Gke = "gke",
  Ocp = "ocp",
  Tanzu = "tanzu",
  Baremetal = "baremetal",
}

export interface MinioSite {
  id?: string;
  name?: string;
  resources?: MinioSiteResources;
  setupType?: MinioSetupType;
  status?: MinioSiteStatus;
  /** @format int64 */
  sysCreated?: string;
}

export interface MinioSiteList {
  items?: MinioSite[];
}

export interface MinioSiteResources {
  tenants?: MinioTenant[];
  observes?: MinioObserve[];
  catalogs?: MinioCatalog[];
  keyManagers?: MinioKeyManager[];
  firewalls?: MinioFirewall[];
  operator?: MinioOperator;
  directPV?: MinioDirectPV;
}

/** @default "Online" */
export enum MinioSiteStatus {
  Online = "Online",
  Offline = "Offline",
}

export interface MinioTenant {
  id?: string;
  name?: string;
  namespace?: string;
  pools?: MinioPool[];
  /** @format int64 */
  capacity?: string;
  /** @format int64 */
  usage?: string;
  /** @format int64 */
  rawCapacity?: string;
  /** @format int64 */
  rawUsage?: string;
  status?: MinioTenantStatus;
  /** @format int64 */
  sysCreated?: string;
}

export interface MinioTenantStatus {
  healthStatus?: string;
  healthMessage?: string;
  /** @format int32 */
  drivesOnline?: number;
  /** @format int32 */
  drivesOffline?: number;
  currentState?: string;
}

export interface MinioValidationError {
  field?: string;
  contrantId?: string;
  message?: string;
}

export interface ProtobufAny {
  "@type"?: string;
  [key: string]: any;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key],
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== "string"
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams,
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (
    cancelToken: CancelToken,
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { "Content-Type": type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === "undefined" || body === null
            ? null
            : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title enterprise.proto
 * @version version not set
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags EnterpriseBackend
     * @name ListSites
     * @request GET:/api/v2/sites
     */
    listSites: (
      query?: {
        /** @format int32 */
        offset?: number;
        /** @format int32 */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<MinioSiteList, GooglerpcStatus>({
        path: `/api/v2/sites`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags EnterpriseBackend
     * @name Ping
     * @request GET:/api/v2/sites/{siteID}/ping
     */
    ping: (
      siteId: string,
      query?: {
        namespace?: string;
        resourceID?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MinioRPCError, GooglerpcStatus>({
        path: `/api/v2/sites/${siteId}/ping`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
}
